import React, { useState } from "react";
import "../../styles/Authentication.scss";
import { useLabelsContext } from "../../context/LabelsContext";
import { motion } from "framer-motion";
import { fadeScale } from "../../styles/MotionFramerAnimations";
import { useConfigContext } from "../../context/ConfigContext";
import { useUserContext } from "../../context/UserContext";
import { useClubContext } from "../../context/ClubContext";
import { LoginFormHeader } from "./LoginFormHeader";
import { useLoginForm } from "../../hooks/useLoginForm";
import { useAuthContext } from "../../context/AuthContext";
import { ApiResponse, ApiStatus } from "../../models/api-response";
import { JoinFree } from "./JoinFree";
import { recoverProfile } from "../../services/auth-service";

export const ProfileRecovery: React.FC = () => {
	const { club } = useClubContext();
	const { labels } = useLabelsContext();
	const { config } = useConfigContext();
	const { user } = useUserContext();
	const { loginMethod } = useAuthContext();
	const [isLoading, setIsLoading] = useState<boolean>(false);
	const [apiMessage, setApiMessage] = useState<string | null>(null);

	const {
		register,
		handleSubmit,
		getValues,
		errors,
		loginForm,
		getErrorMessage,
		setError,
	} = useLoginForm();

	const onSubmit = async () => {
		setIsLoading(true);
		setApiMessage(null);
		const loginData: string = getValues(loginMethod) || "";

		recoverProfile(config, loginData, club?.bookingDomain)
			.then((response: ApiResponse<string>) => {
				// success
				if (response.Status === ApiStatus.Success && response.Data) {
					setApiMessage(response.Data);
				}
				// api error
				if (
					response.Status === ApiStatus.Error &&
					response.Errors?.length
				) {
					const errorMessage = response.Errors[0]?.Message;

					setError(loginMethod, {
						type: "manual",
						message: errorMessage,
					});
				}
			})
			.catch(() => {
				setError(loginMethod, {
					type: "manual",
					message: labels?.["ApiErrorsLabels1"],
				});
			})
			.finally(() => setIsLoading(false));
	};
	return (
		<div className='login-form-container'>
			<LoginFormHeader />
			<form
				className='simplex-club-form'
				onSubmit={handleSubmit(onSubmit)}
			>
				<div className='form-col'>
					{getErrorMessage("email") && (
						<motion.div {...fadeScale} className='error-container'>
							<span
								className={`error-message key-${getErrorMessage("email")?.key}`}
							>
								{getErrorMessage("email")?.message}
							</span>
						</motion.div>
					)}
					{apiMessage && (
						<motion.div
							{...fadeScale}
							className='success-container'
						>
							<span className='success-message'>
								{apiMessage}
							</span>
						</motion.div>
					)}
					<div
						className={`form-field ${errors.email ? "has-error" : ""}`}
					>
						<input
							id='email'
							type='email'
							placeholder=' '
							defaultValue={
								user && user.Email ? user?.Email : undefined
							}
							{...register("email", loginForm.email)}
						/>
						<label className='form-label' htmlFor='email'>
							{labels?.["Email"]}
						</label>
					</div>
					<button
						type='submit'
						className='form-submit'
						disabled={isLoading}
					>
						{isLoading && (
							<span className='loader secondary'></span>
						)}
						{labels?.["Continue"]}
					</button>
					<div className='form-secondary-action'>
						<JoinFree />
					</div>
				</div>
			</form>
		</div>
	);
};
